import { OndigoNS } from '../modules/main.js';

!function ($) {
    // Class Definition
    OndigoNS.Filter = function (element) {
        this.$filter = $(element);
        this.$body = $('body');
        this.$window = $(window);
        this.$checkboxes = $('input[type="checkbox"]', this.$filter);
        this.$groupCheckboxes = $('input[type="checkbox"][data-category]', this.$filter);
        this.$berlinCheckbox = $('.berlin', this.$filter);
        this.$townshipCheckboxes = $('input[type="checkbox"][data-township]', this.$filter).not(this.$berlinCheckbox);
        this.$objectid = $('#objectid', this.$filter);
        this.$objectidbutton = $('#objectidbutton', this.$filter);
        this.$resultGroups = $('.resultGroup', this.$filter);
        this.$results = $('.result', this.$filter);
        this.$usedFilters = $('.usedFilters', this.$filter);
        this.$clearAll = $('.clearAll', this.$usedFilters);
        this.$scrollToTop = null;
        this.$openFilter = $('.openFilter', this.$filter);
        this.$filterOptions = $('.filterOptions', this.$filter);
        this.$filterResults = $('.filterResults', this.$filter);
        this.$noClickOverlay = $('.noClickOverlay', this.$filter);
        this.$counter = $('.counter', this.$filter);
        this.$count = $('.count', this.$counter);
        this.$sum = $('.sum', this.$counter);
        this.alwaysShowBerlin = false;
        this.$idNotFound = $('.idNotFound', this.$filter);
        this.$backLink = $('.backLink', this.$filter);
        this.isFirstDesktopView = true;
        this.breakpointMax=1000;

        this.idFound = false;

        this.visibleCategories = [];
        this.visibleTownships = [];
        this.checkedCategories = [];
        this.checkedTownships = [];

        this.init();
    };

    OndigoNS.Filter.prototype = {
        init: function () {
            var _scope = this,
                $idElement;

            this.$sum.text(this.$results.length);
            this.updateCount();
            this.updateCheckboxCount();
            this.handleDetailBacklink();

            if (OndigoNS.Utils.hasTouchscreen()) {
                this.$window.on('orientationchange', function () {
                    setTimeout(function () {
                      _scope.handleResize(_scope);
                    }, 300);
                });
            }
            else {
                this.$window.on('resize', function () {
                    _scope.handleResize(_scope);
                });
            }


            this.$filterResults.css('min-height', this.$filterOptions.height());
            this.$openFilter.on('click', function () {
                _scope.openFilter();
            });
            this.$checkboxes.on('change', function () {
                if ($(this).hasClass('berlin')) {
                    _scope.handleBerlin($(this));
                }
                else if ($(this).data('category')) {
                    _scope.handleGroups();
                }
                else {
                    _scope.handleTownships();
                }
                _scope.handleUsedFilters($(this));
                _scope.updateNumbers();
                _scope.updateCount();
            });
            this.$clearAll.on('click', function () {
                $('label', _scope.$usedFilters).remove();
                _scope.$checkboxes.prop('checked', '');
                _scope.$clearAll.removeClass('visible');
                _scope.$checkboxes.prop('disabled', '');
                _scope.$results.removeClass('hide').addClass('show');
                _scope.$resultGroups.removeClass('hide').addClass('show');
                _scope.$objectid.val('');
                _scope.updateCount();
                _scope.updateCheckboxCount();
            });
            this.$objectidbutton.on('click', function () {
                $idElement = $('[data-object-id="' + _scope.$objectid.val() + '"]', _scope.$filter);
                if ($idElement.length) {
                    if (!_scope.idFound) {
                        if(_scope.$idNotFound.is(':visible')) {
                            if(_scope.$idNotFound.hasClass('home')) {
                                _scope.$idNotFound.slideUp();
                            } else {
                                _scope.$idNotFound.fadeOut();
                            }
                        }
                        $('label', _scope.$usedFilters).remove();
                        _scope.$checkboxes.prop('checked', '');
                        _scope.$checkboxes.prop('disabled', 'disabled');
                        _scope.$results.removeClass('show').addClass('hide');
                        _scope.$resultGroups.removeClass('show').addClass('hide');
                        _scope.$clearAll.addClass('visible');
                        $idElement.parent().removeClass('hide').addClass('show');
                        $idElement.parents('.resultGroup').removeClass('hide').addClass('show');
                        _scope.idFound = true;

                        _scope.$usedFilters.prepend('<label class="onIconRightClose idFilter">Objekt-ID: ' + _scope.$objectid.val() + '</label>');

                        $('label.idFilter', _scope.$usedFilters).on('click', function () {
                            $(this).remove();
                            $(this).unbind();
                            _scope.$checkboxes.prop('disabled', '');
                            _scope.$results.removeClass('hide').addClass('show');
                            _scope.$resultGroups.removeClass('hide').addClass('show');
                            _scope.$objectid.val('');
                            if (!$('label', _scope.$usedFilters).length) {
                                _scope.$clearAll.removeClass('visible');
                            }
                        });
                    }
                } else {
                    if (_scope.idFound) {
                        _scope.idFound = false;
                        _scope.$checkboxes.prop('disabled', '');
                        _scope.$results.removeClass('hide').addClass('show');
                        _scope.$resultGroups.removeClass('hide').addClass('show');
                    }
                    if(_scope.$idNotFound.hasClass('filter')) {
                        _scope.$idNotFound.fadeIn();
                    }
                }
                _scope.updateCount();
            });

            $('input[type="checkbox"][data-category]:checked', this.$filter).trigger('change');
            $('input[type="checkbox"][data-township]:checked', this.$filter).trigger('change');
        },
        handleResize: function($this){
            if ($this.$window.innerWidth() >=$this.breakpointMax) {
                if($this.isFirstDesktopView) {
                    $this.$filterResults.css('min-height', $this.$filterOptions.height());
                    $this.isFirstDesktopView = false;
                }
            }
        },
        handleBerlin: function ($this) {
            this.alwaysShowBerlin = !!$this.prop('checked');
            this.handleTownships();
        },
        updateCount: function () {
            this.$count.text($('.show .show', this.$filter).length);
        },
        updateCheckboxCount: function () {
            var _scope = this;

            $.each(this.$checkboxes, function() {
                if ($(this).hasClass('berlin')) {
                    $('label[for="' + $(this).attr('id') + '"]', _scope.$filter).find('.count').text($('.result [data-position="Berlin"]', _scope.$filter).length);
                }
                else if ($(this).data('category')) {
                    $('label[for="' + $(this).attr('id') + '"]', _scope.$filter).find('.count').text($('.resultGroup[data-object-category="' + $(this).data('category') + '"] .show', _scope.$filter).length);
                }
                else {
                    $('label[for="' + $(this).attr('id') + '"]', _scope.$filter).find('.count').text($('.result [data-object-township="' + $(this).data('township') + '"]', _scope.$filter).length);
                }
            });
        },
        handleUsedFilters: function ($this) {
            var _scope = this,
                label = '';

            if ($this.prop('checked')) {
                this.$clearAll.addClass('visible');
                label = $('label[for="' + $this.attr('id') + '"]').first().text();
                this.$usedFilters.prepend('<label for="' + $this.attr('id') + '" class="onIconRightClose" >' + label.substring(0, label.indexOf('(')) + '</label>');
                $('label[for="' + $this.attr('id') + '"]', _scope.$usedFilters).on('click', function () {
                    $(this).remove();
                    $(this).unbind();

                    $('#' + $this.attr('id')).prop('checked', '').prop('disabled', '').trigger('change');

                    if (!$('label', _scope.$usedFilters).length) {
                        _scope.$clearAll.removeClass('visible');
                    }
                });
            }
            else {
                $('label[for="' + $this.attr('id') + '"]', this.$usedFilters).remove();
                if (!$('label', this.$usedFilters).length) {
                    this.$clearAll.removeClass('visible');
                }
            }
        },
        handleGroups: function () {
            var _scope = this;
            if ($('input[type="checkbox"][data-category]:checked', this.$filter).length) {
                this.$resultGroups.addClass('hide').removeClass('show');
                this.$results.addClass('hiddenByCategory').removeClass('shownByCategory');
                $.each(this.$groupCheckboxes, function() {
                    if ($(this).prop('checked')) {
                        if (($('.resultGroup[data-object-category="' + $(this).data('category') + '"]', _scope.$filter).find('.show').length) ||
                            (!$('.resultGroup[data-object-category="' + $(this).data('category') + '"]', _scope.$filter).find('.hide').length)) {
                            $('.resultGroup[data-object-category="' + $(this).data('category') + '"]', _scope.$filter).addClass('show').removeClass('hide');
                            $('.result', _scope.$filter).find('[data-object-category="' + $(this).data('category') + '"]').parents('.result').addClass('shownByCategory').removeClass('hiddenByCategory');
                        }
                    }
                });
            }
            else {
                this.$resultGroups.addClass('show').removeClass('hide');
                this.$results.addClass('shownByCategory').removeClass('hiddenByCategory');
                this.checkGroupForHiding();
            }
        },
        handleTownships: function () {
            var _scope = this,
                $element;

            if ($('input[type="checkbox"][data-township]:checked', this.$filter).length) {
                this.$results.addClass('hide').removeClass('show');
                $.each(this.$townshipCheckboxes, function() {
                    $element = $('.resultGroup [data-object-township="' + $(this).data('township') + '"]');
                    if ((_scope.alwaysShowBerlin && ($element.data('position') === 'Berlin')) || $(this).prop('checked')) {
                        $element.parent().addClass('show').removeClass('hide');
                        if (!$('input[type="checkbox"][data-category]:checked', _scope.$filter).length) {
                            $element.parents('.resultGroup').addClass('show').removeClass('hide');
                        }
                    }
                });
            }
            else {
                this.$results.addClass('show').removeClass('hide');
            }
            this.checkGroupForHiding();
            this.handleGroups();
        },
        checkGroupForHiding: function() {
            $.each(this.$resultGroups, function() {
                if ($(this).find('.show').length ||
                    !$(this).find('.hide').length) {
                    $(this).addClass('show').removeClass('hide');
                }
                else {
                    $(this).addClass('hide').removeClass('show');
                }
            });
        },
        openFilter: function () {
            this.$filterOptions.show();
            if (this.$openFilter.hasClass('opened')) {
                this.$noClickOverlay.hide();
                if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                    this.$filterOptions.animate({
                        left: "-325px"
                    }, 350);
                }
                else {
                    this.$filterOptions.animate({
                        left: "-325px"
                    }, 350);
                }
            }
            else {
                this.$noClickOverlay.show();
                this.$noClickOverlay.height(this.$filterOptions.height() + this.$openFilter.height() + 50);
                if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                    this.$filterOptions.animate({
                        left: "-25px"
                    }, 350);
                }
                else {
                    this.$filterOptions.animate({
                        left: "-40px"
                    }, 350);
                }
            }
            this.$openFilter.toggleClass('opened');
        },
        handleDetailBacklink : function () {
            this.$backLink.on('click', function (e) {
                if(document.referrer == (window.location.protocol + '//' + window.location.host + $(this).attr('href'))) {
                    window.history.back();
                    e.preventDefault();
                }
            });
        },
        getVisbleCategoriesAndTownships : function () {
            var _instance = this;
            this.visibleCategories = [];
            this.visibleTownships = [];
            $.each($('.result.shownByCategory.show', this.$filter), function () {
                var visible = $(this);

                _instance.visibleCategories.push(visible.children().data('object-category'));
                _instance.visibleTownships.push(visible.children().data('object-township'));
            });
        },
        updateNumbers : function () {
            var _instance = this;

            this.getVisbleCategoriesAndTownships();
            this.updateCheckboxCount();
            this.getCheckedCheckboxes();

            $.each($('input[type="checkbox"]', this.$filter), function () {
                var checkbox = $(this);
                if(checkbox.data('category')) {
                    var countcat = _instance.getCountVisibleResultData(checkbox.data('category'), _instance.visibleCategories);
                    $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text(countcat);
                    if(!checkbox.prop('checked')) {
                        var availablecat;
                        if(_instance.checkedTownships.length) {
                            availablecat = _instance.getNumberOfResultsByCategoryAndTownship(checkbox, 'category', 'township', _instance.checkedTownships);
                        } else {
                            availablecat = _instance.getNumberOfResultsByData(checkbox.data('category'), 'category');
                        }
                        if(availablecat > 0) {
                            $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text('+' + availablecat);
                        } else {
                            $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text(availablecat);
                        }
                    }
                } else {
                    var counttown = _instance.getCountVisibleResultData(checkbox.data('township'), _instance.visibleTownships);
                    $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text(counttown);
                    if (!checkbox.prop('checked')) {
                        var availabletown;
                        if(_instance.checkedCategories.length) {
                            availabletown = _instance.getNumberOfResultsByCategoryAndTownship(checkbox, 'township', 'category', _instance.checkedCategories);
                        } else {
                            availabletown = _instance.getNumberOfResultsByData(checkbox.data('township'), 'township');
                        }
                        if(availabletown > 0) {
                            $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text('+' + availabletown);
                        } else {
                            $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text(availabletown);
                        }
                    }
                }
            });
            this.resetNumbersIfNoCheckboxChecked();
        },
        getNumberOfResultsByCategoryAndTownship : function (uncheckedCategoryCheckbox, categoryData, townshipData, checkedTownshipArray) {
            var numberOfResults = [];

            if(checkedTownshipArray.length) {
                $.each(checkedTownshipArray, function () {
                    var checkbox = $(this);
                    if($('.filterResults').find('.result [data-object-'+ categoryData +'="' + uncheckedCategoryCheckbox.data(categoryData) + '"][data-object-'+ townshipData +'="' + checkbox.data(townshipData) + '"]').length) {
                        numberOfResults.push($('.filterResults').find('.result [data-object-'+ categoryData +'="' + uncheckedCategoryCheckbox.data(categoryData) + '"][data-object-'+ townshipData +'="' + checkbox.data(townshipData) + '"]'));
                    }
                });
            }

            return numberOfResults.length;
        },
        getCheckedCheckboxes : function () {
            var _instance = this;

            this.checkedCategories = [];
            this.checkedTownships = [];

            $.each($('input[type="checkbox"]', this.$filter), function () {
                var checkbox = $(this);
                if(checkbox.data('category')) {
                    if(checkbox.prop('checked')) {
                        _instance.checkedCategories.push(checkbox);
                    }
                } else {
                    if(checkbox.prop('checked')) {
                        _instance.checkedTownships.push(checkbox);
                    }
                }
            });
        },
        resetNumbersIfNoCheckboxChecked : function () {
            var _instance = this;

            if(!_instance.checkedCategories.length) {
                $.each($('input[type="checkbox"]', this.$filter), function () {
                    var checkbox = $(this);
                    if(checkbox.data('category')) {
                        var countcat = _instance.getCountVisibleResultData(checkbox.data('category'), _instance.visibleCategories);
                        $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text(countcat);
                    }
                });
            }

            if(!_instance.checkedTownships.length) {
                $.each($('input[type="checkbox"]', this.$filter), function () {
                    var checkbox = $(this);
                    if(!checkbox.data('category')) {
                        var counttown = _instance.getCountVisibleResultData(checkbox.data('township'), _instance.visibleTownships);
                        $('label[for="' + checkbox.attr('id') + '"]', _instance.$filter).find('.count').text(counttown);
                    }
                });
            }
        },
        getNumberOfResultsByData : function (object, data) {
            var number = [];

            $.each(this.$results, function () {
                var result = $(this);
                if(object === result.children().data('object-' + data)) {
                    number.push(result.children().data('object-' + data));
                }
            });

            return number.length;
        },
        getCountVisibleResultData : function (dataname, array) {
            var num = 0;
            for(var i=0;i<array.length;i++){
                if(array[i] === dataname)
                    num++;
            }
            return num;
        },
    };

    // plugin definition
    $.fn.filterConfig = function () {
        return new OndigoNS.Filter(this);
    };
    $.fn.filterConfig.Constructor = OndigoNS.Filter;

}(window.jQuery);


$(document).ready(function () {

    var $filter = $('.filter');
    if ($filter.length) {
        $filter.filterConfig();
    }
});